import { useTranslation } from "react-i18next";
import cn from "classnames";

import { WizardUser } from "shared/components/WizardNew/types";

import { isDesktop } from "shared/constants/envVariables";

import { WizardUserMenu } from "./WizardUserMenu";

import styles from "@platformAssets/components/Wizard.module.scss";

import { ReactComponent as ArrowLeftIcon } from "assets/shared/img/icons/arrow-left.svg";

type WizardButtonsProps = {
  variant: "wizard" | "welcome";

  onBack?: () => void;
  onNext?: () => void;
  onSkip?: () => void;

  showBack?: boolean;
  showNext?: boolean;
  showSkip?: boolean;

  isContinueAvailable?: boolean;
  userData: WizardUser | null;
};

export const WizardButtons = ({
  variant,

  onBack,
  onNext,
  onSkip,

  showBack = true,
  showNext = true,
  showSkip = false,

  isContinueAvailable = true,
  userData,
}: WizardButtonsProps) => {
  const { t } = useTranslation("wizardNew");

  const renderBack = (): JSX.Element => {
    if (!showBack) return <div className={styles.wizardButtonPrevious} />;

    return (
      <div className={styles.wizardButtonPrevious}>
        <button onClick={onBack}>
          {isDesktop ? t("buttonBack") : <ArrowLeftIcon />}
        </button>
      </div>
    );
  };

  const renderRightActions = (): JSX.Element => {
    return (
      <div className={styles.actionButtons}>
        <div className={styles.wizardButtonNext}>
          {showNext && (
            <button
              className={!isContinueAvailable ? styles.disabled : ""}
              disabled={!isContinueAvailable}
              onClick={onNext}
            >
              {t("buttonNext")}
            </button>
          )}
        </div>

        <div className={styles.wizardButtonSkip}>
          {showSkip && <button onClick={onSkip}>{t("buttonSkip")}</button>}
        </div>
      </div>
    );
  };

  return (
    <div
      className={cn(styles.wizardButtons, {
        [styles.welcomeButtons]: variant === "welcome",
      })}
    >
      {renderBack()}

      {variant !== "welcome" && renderRightActions()}

      <div className={styles.headerContent}>
        <div
          className={cn(styles.headerWrap, {
            [styles.single]: !userData,
          })}
        >
          <a href="/app/" className={styles.wizardLogo} />

          {userData && <WizardUserMenu userData={userData} />}
        </div>
      </div>
    </div>
  );
};
